import { api } from "api/api";
import { AxiosError } from "axios";
import Produto from "model/administracao/cadastro/produto/Produto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import OrdemProducao from "model/producao/OrdemProducao";
import { DataTableFilterMeta } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class QualidadeProdutoAcabadoService implements BaseServiceCadastros<OrdemProducao> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/qualidade/produtoAcabado/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .get(`/qualidade/produtoAcabado/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(itemPlano: OrdemProducao) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .post(`/qualidade/produtoAcabado/incluir`, JSON.stringify(itemPlano))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(itemPlano: OrdemProducao) {
        return new Promise<OrdemProducao>((resolve, reject): void => {
            api
                .put(`/qualidade/produtoAcabado/editar`, JSON.stringify(itemPlano))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/qualidade/produtoAcabado/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getProdutos() {
        return new Promise<Array<Produto>>((resolve, reject): void => {
            api
                .get(`qualidade/produtoAcabado/produtos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }
    
}

export default QualidadeProdutoAcabadoService;